import {AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild} from "@angular/core";
import {EntityData, NumberUtils} from "@fedeltapointofsale/data-client";
import {TranslateService} from "@ngx-translate/core";
import {TillData} from "../../float.data";
import {FUIModalsService} from "@fedeltapointofsale/ui";
import {EditGridComponent} from "../../../../framework/entity/edit/edit-grid/edit-grid.component";

export class TailNoteValue extends EntityData<TailNoteValue> {
    constructor(public name: string, public displayName: string, public coefficient: number, public value: number) {
        super();
    }

    get valueInput(): number {
        return this.value;
    }

    set valueInput(value: number) {
        if (value) {
            this.value = Math.trunc(value);
        }
    }

    get total(): number {
        return (this.value | 0) * this.coefficient;
    }
}

@Component({
    selector: "cash-management-edit-cash-calc",
    templateUrl: "./cash-management-edit-cash-calc.component.html"
})
export class CashManagementEditCashCalcComponent implements AfterContentChecked {

    public static readonly definitionValues: { name: string, coefficient: number }[] = [{name: "note100", coefficient: 100}, {name: "note50", coefficient: 50},
        {name: "note20", coefficient: 20}, {name: "note10", coefficient: 10}, {name: "note5", coefficient: 5}, {name: "coin200", coefficient: 2},
        {name: "coin100", coefficient: 1}, {name: "coin50", coefficient: 0.50}, {name: "coin20", coefficient: 0.2}, {name: "coin10", coefficient: 0.1},
        {name: "coin5", coefficient: 0.05}];

    @ViewChild(EditGridComponent) editGridComponent: EditGridComponent;

    @Output() onConfirm: EventEmitter<number> = new EventEmitter();

    private _till: TillData;

    readonly: boolean;


    data: TailNoteValue[] = [];

    state: boolean = true;

    constructor(private translateService: TranslateService, private modalsService: FUIModalsService, private changeDetectorRef: ChangeDetectorRef) {
    }

    set till(till: TillData) {
        this._till = till;
        this.data = [];
        CashManagementEditCashCalcComponent.definitionValues.forEach(value => {
            this.translateService.get("wbo.cash-management.edit.field." + value.name + ".label").subscribe((translation) => {
                this.data = [].concat(this.data);
                this.data.push(new TailNoteValue(value.name, translation,
                    value.coefficient, this.till[value.name]));
            });
        });
    }

    get till(): TillData {
        return this._till;
    }

    cancel(): void {
        this.modalsService.close(this);
    }

    confirm(): void {
        this.editGridComponent.confirmEditing();
        let total: number = 0;
        this.data.forEach(value => {
            this.till[value.name] = value.value | 0;
            total += value.total;
        });
        this.modalsService.close(this);
        this.onConfirm.emit(total);
    }

    ngAfterContentChecked(): void {
        this.changeDetectorRef.detectChanges();
    }

    calculateTotal(): number {
        return NumberUtils.roundValue(this.data.map(value => value.total).reduce((previousValue, currentValue) => NumberUtils.roundValue(previousValue + currentValue, 2), 0), 2);
    }

    clear(): void {
        this.editGridComponent.cancelEditing();
        this.data.forEach(value => value.value = 0);
    }

    setReadonly(): void {
        this.readonly = true;
    }
}
